import React from "react";

function BlueCircleGauge({fill}) {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.11291 16.3455C9.04569 18.6161 14.0746 17.2685 16.3453 13.3355C18.6159 9.40261 17.2685 4.37367 13.3358 2.10308C9.40299 -0.167504 4.3741 1.18009 2.10342 5.11302C-0.167256 9.04594 1.18014 14.0749 5.11291 16.3455Z" fill="#01B5DE" stroke="white" stroke-width="2"/>
    </svg>

  );
}

export default BlueCircleGauge;
